/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceCategoryQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceCategoryQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceCategoryQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceCategoryQueryOperator>): ResourceCategoryQueryOperator {
        let obj = Object.assign(new ResourceCategoryQueryOperator(), model);
        ResourceCategoryQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceCategoryQueryOperator>): ResourceCategoryQueryOperator {
        if (!model) return null;
        return ResourceCategoryQueryOperator.newInstance(<ResourceCategoryQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceCategoryQueryOperator) {
        if (!obj) return;

        models.ResourceCategoryQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceCategoryQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceCategoryQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource categories to include
     */
    resource_categories: Array<string>;

}
